// Miky Motorsport - casove medaile (J): absolutni vyzva na cas, nezavisla na pozici.
// Cil = referencni kolo trate (REF_LAP, zmerene AI tempo na zakladnim aute) × pocet
// kol × nasobitel medaile. Cista logika (bez DOM/THREE) - testovatelne v Node.
//
// gold < silver < bronze (gold je nejtezsi = nejmensi cilovy cas). Nasobitele jsou
// kalibrovane tak, aby bronz byl dosazitelny cistou jizdou na zakladnim aute, silver
// vyzadoval skvelou jizdu / lepsi auto a gold byl meta na vyladene auto.

export const TIME_MEDAL_MUL = { gold: 0.93, silver: 1.02, bronze: 1.12 };
const ORDER = ['gold', 'silver', 'bronze'];

// Emoji medaile pro UI (gold/silver/bronze), '' kdyz zadna. Sdileno mezi game/ui,
// aby mapovani existovalo jen na jednom miste (drive zduplikovane v obou souborech).
const MEDAL_ICON = { gold: '🥇', silver: '🥈', bronze: '🥉' };
export function medalIcon(medal) {
  return MEDAL_ICON[medal] || '';
}

// Ikona medaile s odsazujici mezerou jako prefix ("🥇 "), nebo '' kdyz zadna.
// Sdileno pro toasty/UI radky, kde se medaile pripina pred text (drive opakovany
// ternary `ic ? ic + ' ' : ''` na vic mistech).
export function medalPrefix(medal) {
  const ic = medalIcon(medal);
  return ic ? ic + ' ' : '';
}

// Cas v ms -> "m:ss.cc" (napr. 83210 -> "1:23.21"). null -> "-". Sdilena formatovaci
// pomucka pro toasty/TT vypis (drive identicka kopie v game.js i ui.js).
export function fmtMs(ms) {
  if (ms == null) return '-';
  const s = ms / 1000, m = Math.floor(s / 60);
  return `${m}:${(s - m * 60).toFixed(2).padStart(5, '0')}`;
}

// Cilovy cas (ms) pro danou medaili na trati s referencnim kolem refLapSec a poctem kol.
export function targetTimeMs(refLapSec, laps, tier) {
  const mul = TIME_MEDAL_MUL[tier];
  if (!mul || !(refLapSec > 0) || !(laps > 0)) return null;
  return refLapSec * laps * mul * 1000;
}

// Vsechny tri cile (ms) najednou pro UI.
export function targetTimes(refLapSec, laps) {
  return {
    gold: targetTimeMs(refLapSec, laps, 'gold'),
    silver: targetTimeMs(refLapSec, laps, 'silver'),
    bronze: targetTimeMs(refLapSec, laps, 'bronze'),
  };
}

// Nejlepsi dosazena casova medaile za totalMs (nizsi cas = lepsi) nebo null.
// Vraci prvni (nejlepsi) tier, jehoz cil je splnen - protoze gold cil < silver < bronze,
// staci projit od gold dolu.
export function timeMedalFor(totalMs, refLapSec, laps) {
  if (!(totalMs > 0)) return null;
  for (const tier of ORDER) {
    const t = targetTimeMs(refLapSec, laps, tier);
    if (t != null && totalMs <= t) return tier;
  }
  return null;
}

// Souhrn casovych medaili napric vsemi tratemi (pro tally v UI).
//   timeTrials = profile.timeTrials ({ "<id>_<laps>": { totalMs } })
//   trackOrder = pole id; refLapOf(id) -> sekundy; laps = pocet kol TT (default 3)
export function timeMedalTally(timeTrials, trackOrder, refLapOf, laps = 3) {
  let gold = 0, silver = 0, bronze = 0, none = 0;
  for (const id of trackOrder) {
    const pb = timeTrials?.[`${id}_${laps}`]?.totalMs;
    const m = pb ? timeMedalFor(pb, refLapOf(id), laps) : null;
    if (m === 'gold') gold++;
    else if (m === 'silver') silver++;
    else if (m === 'bronze') bronze++;
    else none++;
  }
  return { gold, silver, bronze, none, total: gold + silver + bronze, tracks: trackOrder.length };
}
